import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { LeadForm, ValidationDialog } from 'components';
import { useFilterStyles, useHomePageStyles } from '../styles';

const Home: React.FC = () => {
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [persons, setPersons] = useState(1);

  const classes = useHomePageStyles();
  const { filter } = useFilterStyles({ color: 'black', opacity: .5, fontColor: undefined });

  const handleOpenValidationDialog: (persons: number) => void = (persons) => {
    setValidationDialogOpen(true);
    setPersons(persons);
  };
  const handleCloseValidationDialog = () => {
    setValidationDialogOpen(false);
    setPersons(1);
  };
  return (
    <Grid
      component="main"
      container
      className={classes.root}
      direction="column"
      wrap="nowrap"
    >
      <ValidationDialog
        open={validationDialogOpen}
        onClose={handleCloseValidationDialog}
        persons={persons}
      />
      <Grid wrap="nowrap" container alignItems="center" justify="center" direction="column" item
            className={`${classes.intro} ${filter}`}>
        <Typography align="center" variant="h2">Typhus Bronx au Mas La Font</Typography>
        <Typography align="center" variant="subtitle1">19 juin 2021</Typography>
        <Typography align="center" variant="body1">Les réservatiosn sont terminées</Typography>
      </Grid>
      {/*<Grid*/}
      {/*  container*/}
      {/*  alignItems="center"*/}
      {/*  justify="center"*/}
      {/*  item*/}
      {/*  className={classes.leadFormContainer}*/}
      {/*>*/}
      {/*  <LeadForm onOpenValidationDialog={handleOpenValidationDialog}/>*/}
      {/*</Grid>*/}
    </Grid>
  );
};

export default Home;